import { render, staticRenderFns } from "./VisitContactHostRedirect.vue?vue&type=template&id=19c0dae0&scoped=true"
import script from "./VisitContactHostRedirect.vue?vue&type=script&lang=js"
export * from "./VisitContactHostRedirect.vue?vue&type=script&lang=js"
import style0 from "./VisitContactHostRedirect.vue?vue&type=style&index=0&id=19c0dae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0dae0",
  null
  
)

export default component.exports